module.exports = __webpack_public_path__ + "catalog/items/firesafety/fire-extinguisher-CO2/fire-extinguisher-CO2.svg";